module.exports = __webpack_public_path__ + "img/back.ab806b82.svg";